/**
 * Lỗi có mã của khung xem trước — APM-MYF-d, docs/plan-my-files.md §4.3.
 *
 * Mã chứ không phải chuỗi: màn hình lỗi dịch theo `code` (khoá
 * `myFiles.preview.error.<code>`), và một lỗi không mang mã (thư viện ném, nạp
 * chunk hỏng) rơi về `library` — không bao giờ là màn hình trắng.
 */
export type PreviewErrorCode =
  | 'tooLarge'
  | 'fetchFailed'
  | 'http'
  | 'media'
  | 'library'
  /** Trình duyệt thiếu API mà thư viện cần (pdf.js 6: `AbortSignal.any`) — APM-MYF-e. */
  | 'browser'
  /** PDF có mật khẩu — không hỏi mật khẩu trên trang, tải về để mở. */
  | 'password'
  /** `.chilldoc` hỏng: không phải JSON, sai vỏ, hoặc `doc` sai schema — APM-CD-a. */
  | 'chilldocInvalid'
  /** `.chilldoc` do bản app mới hơn ghi — không mở để sửa kẻo lưu đè mất dữ liệu. */
  | 'chilldocNewer';

export class PreviewError extends Error {
  constructor(
    readonly code: PreviewErrorCode,
    /** Tham số cho câu dịch — `limit` (bytes) với `tooLarge`, `status` với `http`. */
    readonly params: Readonly<Record<string, number>> = {},
  ) {
    super(`preview:${code}`);
    this.name = 'PreviewError';
  }
}
